export default
  mounted: ->
    return unless (this != @$root); # guard against running this in the root component.
    return unless (@$el?.querySelectorAll?) # guard against components with top-level v-if. comments don't have querySelectorAll
    @$nextTick =>
      @inlineSVG()
  methods:
    inlineSVG: (id) ->
      if id == undefined
        @inlineSVGClass()
      else
        @inlineSVGId(id)
    inlineSVGId: (id) ->    
      return unless id  
      element = document.getElementById(id)
      return unless element
      @inlineSVGElement(element)
    inlineSVGClass: (classname) ->
      classname = 'inlineSVG' unless classname
      #elements = document.getElementsByClassName(classname)
      elements = @$el.querySelectorAll(".#{classname}") # restrict this action to just those in this component
      return if !elements || elements.length <= 0
      await Promise.all(
        Array.from(elements).map (element) =>
          @inlineSVGElement(element)
          element.classList.remove(classname)     
      )
    inlineSVGElement: (element) ->
      elementSRC = element.getAttribute('src')
      return if !elementSRC
      try
        response = await fetch(elementSRC)
        text = await response.text()
        parser = new DOMParser
        xmlDoc = parser.parseFromString text, "text/xml"
        SVG = xmlDoc.getElementsByTagName('svg')[0]
        return if !SVG
        SVG.removeAttribute('xmlns:a')
        viewBox = SVG.getAttribute('viewBox')
        height = SVG.getAttribute('height')
        width = SVG.getAttribute('width')
        if (!viewBox && height && width)
          SVG.setAttribute('viewBox', "0 0 #{width} #{height}")
        element.innerHTML = SVG.innerHTML
        element.setAttribute('xmlns', SVG.getAttribute('xmlns'))
        element.setAttribute('viewBox', SVG.getAttribute('viewBox'))
        element.setAttribute('role', 'none')
        element.removeAttribute('src')
      catch error
        return